import fileTypes from './types';
import { SAGA_REQUEST_KEY } from 'Constants';

export const initialStates = {
	uploaded: null,
	deleted: null,
	blob: null,
};

const fileReducers = (state = initialStates, action) => {
	switch (action.type) {
		case fileTypes.UPLOAD.SUCCESS: {
			let key = action?.payload?.[SAGA_REQUEST_KEY.LOADING_ID] || 'uploaded';
			return { ...state, [key]: action?.payload };
		}

		case fileTypes.UPLOAD.CLEAR: {
			let key = action?.payload?.key || 'uploaded';
			return { ...state, [key]: null };
		}

		case fileTypes.DELETE.SUCCESS: {
			return { ...state, deleted: action?.payload };
		}

		case fileTypes.DELETE.CLEAR: {
			return { ...state, deleted: null };
		}

		case fileTypes.READ_FROM_PATH.SUCCESS: {
			let key = 'blob';
			key +=
				action?.payload?.requestAction?.[SAGA_REQUEST_KEY.LOADING_ID] || '';

			return { ...state, [key]: action?.payload?.blob };
		}

		case fileTypes.READ_FROM_PATH.CLEAR: {
			const key = action?.payload?.key || 'blob';
			return { ...state, [key]: null };
		}

		default:
			return state;
	}
};

export default fileReducers;
